<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.bi_code }}</em>
          </div>
        </div>
        <div class="weui-form-preview__bd">
          <custom-layout :view-config="customViewConfig">
            <div class="weui-form-preview__item" slot="bi_custname">
              <label class="weui-form-preview__label">{{
                customLabel.bi_custname || "客户名称"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ form.main.bi_custname }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="bi_date">
              <label class="weui-form-preview__label">{{
                customLabel.bi_date || "日期"
              }}</label>
              <span
                class="weui-form-preview__value"
                v-format="'yyyy-MM-dd'"
                key="yyyy-MM-dd"
                >{{ form.main.bi_date }}</span
              >
            </div>
            <div class="weui-form-preview__item" slot="bi_currency">
              <label class="weui-form-preview__label">{{
                customLabel.bi_currency || "币种"
              }}</label>
              <span
                class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ form.main.bi_currency }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="bi_payments">
              <label class="weui-form-preview__label">{{
                customLabel.bi_payments || "收款方式"
              }}</label>
              <span class="weui-form-preview__value">
                {{ form.main.sa_payments }}
                <span v-if="form.main.bi_payments">{{
                  form.main.bi_payments
                }}</span>
                <span v-if="form.main.bi_rate && form.main.bi_rate != 1"
                  >/ {{ form.main.bi_rate }}</span
                >
              </span>
            </div>
            <div class="weui-form-preview__item" slot="bi_paydate">
              <label class="weui-form-preview__label">{{
                customLabel.bi_paydate || "应收日期"
              }}</label>
              <span
                class="weui-form-preview__value"
                v-format="'yyyy-MM-dd'"
                key="yyyy-MM-dd"
                >{{ form.main.bi_paydate }}</span
              >
            </div>
            <div class="weui-form-preview__item" slot="bi_refno">
              <label class="weui-form-preview__label">{{
                customLabel.bi_refno || "税票号"
              }}</label>
              <span class="weui-form-preview__value">{{
                form.main.bi_refno
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="cu_bankaccount">
              <label class="weui-form-preview__label">{{
                customLabel.cu_bankaccount || "开户银行"
              }}</label>
              <span class="weui-form-preview__value">{{
                form.main.cu_bankaccount
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="cu_bankcode">
              <label class="weui-form-preview__label">{{
                customLabel.cu_bankcode || "开户账号"
              }}</label>
              <span class="weui-form-preview__value">{{
                form.main.cu_bankcode
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="cu_invoiceinfo">
              <label class="weui-form-preview__label">{{
                customLabel.cu_invoiceinfo || "开票地址"
              }}</label>
              <span class="weui-form-preview__value">{{
                form.main.cu_invoiceinfo
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="cu_nsrzh">
              <label class="weui-form-preview__label">{{
                customLabel.cu_nsrzh || "社会信用代码"
              }}</label>
              <span class="weui-form-preview__value">{{
                form.main.cu_nsrzh
              }}</span>
            </div>
            <custom-field
              :readOnly="true"
              :label="customLabel.bi_text1 || '自定义字段1'"
              v-model="form.main.bi_text1"
              slot="bi_text1"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.bi_text2 || '自定义字段2'"
              v-model="form.main.bi_text2"
              slot="bi_text2"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.bi_text3 || '自定义字段3'"
              v-model="form.main.bi_text3"
              slot="bi_text3"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.bi_text4 || '自定义字段4'"
              v-model="form.main.bi_text4"
              slot="bi_text4"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.bi_text5 || '自定义字段5'"
              v-model="form.main.bi_text5"
              slot="bi_text5"
              hidden="true"
            />
          </custom-layout>
        </div>
      </div>

      <collapse
        class="form-preview weui-form-preview"
        :title="'明细（' + form.items.length + '条）'"
      >
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.sd_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="bd_prodname">
              <label class="weui-form-preview__label">{{
                customLabel.bd_prodname || "产品名称"
              }}</label>
              <span
                class="weui-form-preview__value text-link"
                @click="showProduct(item)"
                >{{ item.bd_prodname }}</span
              >
            </div>
            <div
              class="weui-form-preview__item"
              v-if="item.bd_orispeccode"
              slot="bd_orispeccode"
            >
              <label class="weui-form-preview__label">{{
                customLabel.bd_orispeccode || "型号"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.bd_orispeccode
              }}</span>
            </div>

            <div class="weui-form-preview__item" slot="bd_qty">
              <label class="weui-form-preview__label">{{
                customLabel.bd_qty || "数量"
              }}</label>
              <span class="weui-form-preview__value"
                >{{ item.bd_qty }} {{ item.productDTO.pr_unit }}</span
              >
            </div>

            <div class="weui-form-preview__item" slot="bd_price">
              <label class="weui-form-preview__label">{{
                customLabel.bd_price || "含税单价(元)"
              }}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.bd_price, "#,##0.####")
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="bd_total">
              <label class="weui-form-preview__label">{{
                customLabel.bd_total || "价税合计(元)"
              }}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.bd_total, "#,##0.####")
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="bd_nettotal">
              <label class="weui-form-preview__label">{{
                customLabel.bd_nettotal || "不含税金额(元)"
              }}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.bd_nettotal, "#,##0.####")
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="bd_costprice">
              <label class="weui-form-preview__label">{{
                customLabel.bd_costprice || "成本单价(元)"
              }}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.bd_costprice, "#,##0.####")
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="bd_costamount">
              <label class="weui-form-preview__label">{{
                customLabel.bd_costamount || "成本金额(元)"
              }}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.bd_costamount, "#,##0.####")
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="bd_netprice">
              <label class="weui-form-preview__label">{{
                customLabel.bd_netprice || "不含税单价(元)"
              }}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.bd_netprice, "#,##0.####")
              }}</span>
            </div>

            <div class="weui-form-preview__item" slot="bd_taxrate">
              <label class="weui-form-preview__label">{{
                customLabel.bd_taxrate || "税率"
              }}</label>
              <span class="weui-form-preview__value">{{ bd_taxrate }}%</span>
            </div>
            <div class="weui-form-preview__item" slot="bd_prodcode">
              <label class="weui-form-preview__label">{{
                customLabel.bd_prodcode || "产品编号"
              }}</label>
              <span
                class="weui-form-preview__value text-link"
                @click="showProduct(item)"
                >{{ item.bd_prodcode }}</span
              >
            </div>
            <div
              class="weui-form-preview__item"
              slot="bd_brand"
              v-if="item.bd_brand"
            >
              <label class="weui-form-preview__label">{{
                customLabel.bd_brand || "厂家/品牌"
              }}</label>
              <span class="weui-form-preview__value">{{ item.bd_brand }}</span>
            </div>
            <div
              class="weui-form-preview__item"
              v-if="item.bd_spec"
              slot="bd_spec"
            >
              <label class="weui-form-preview__label">{{
                customLabel.bd_spec || "规格"
              }}</label>
              <span class="weui-form-preview__value">{{ item.bd_spec }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_pocode">
              <label class="weui-form-preview__label">{{
                customLabel.pd_pocode || "客户PO"
              }}</label>
              <span class="weui-form-preview__value">{{ item.pd_pocode }}</span>
            </div>
            <div class="weui-form-preview__item" slot="bd_ordercode">
              <label class="weui-form-preview__label">{{
                customLabel.bd_ordercode || "订单号"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.bd_ordercode
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="bd_orderdetno">
              <label class="weui-form-preview__label">{{
                customLabel.bd_orderdetno || "订单序号"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.bd_orderdetno
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="bd_inoutno">
              <label class="weui-form-preview__label">{{
                customLabel.bd_inoutno || "出入库单号"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.bd_inoutno
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="bd_pdno">
              <label class="weui-form-preview__label">{{
                customLabel.bd_pdno || "出入库序号"
              }}</label>
              <span class="weui-form-preview__value">{{ item.bd_pdno }}</span>
            </div>
            <div class="weui-form-preview__item" slot="bd_checkcode">
              <label class="weui-form-preview__label">{{
                customLabel.bd_checkcode || "对账单号"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.bd_checkcode
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="bd_checkdetno">
              <label class="weui-form-preview__label">{{
                customLabel.bd_checkdetno || "对账单序号"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.bd_checkdetno
              }}</span>
            </div>
            <div
              class="weui-form-preview__item"
              v-if="item.bd_remark"
              slot="bd_remark"
            >
              <label class="weui-form-preview__label">{{
                customLabel.bd_remark || "备注"
              }}</label>
              <span class="weui-form-preview__value">{{ item.bd_remark }}</span>
            </div>

            <custom-field
              :readOnly="true"
              :label="customLabel.bd_text1 || '自定义字段1'"
              v-model="item.bd_text1"
              slot="bd_text1"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.bd_text2 || '自定义字段2'"
              v-model="item.bd_text2"
              slot="bd_text2"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.bd_text3 || '自定义字段3'"
              v-model="item.bd_text3"
              slot="bd_text3"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.bd_text4 || '自定义字段4'"
              v-model="item.bd_text4"
              slot="bd_text4"
              hidden="true"
            />
            <custom-field
              :readOnly="true"
              :label="customLabel.bd_text5 || '自定义字段5'"
              v-model="item.bd_text5"
              slot="bd_text5"
              hidden="true"
            />
          </custom-layout>
        </div>
      </collapse>
      

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">应收金额(元)</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{
              form.main.bi_amount
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">税额(元)</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{
              form.main.bi_taxamount
            }}</span>
          </div>
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item" v-if="form.main.bi_man">
            <label class="weui-form-preview__label">业务员</label>
            <span class="weui-form-preview__value">{{ form.main.bi_man }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.creatorName">
            <label class="weui-form-preview__label">录入人</label>
            <span class="weui-form-preview__value">{{
              form.main.creatorName
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.bi_auditman">
            <label class="weui-form-preview__label">审核人</label>
            <span class="weui-form-preview__value">{{
              form.main.bi_auditman
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.bi_auditdate">
            <label class="weui-form-preview__label">{{
              customLabel.bi_auditdate || "审核日期"
            }}</label>
            <span class="weui-form-preview__value">{{
              dateFormat(form.main.bi_auditdate, "yyyy-MM-dd")
            }}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.bi_remark">
            <label class="weui-form-preview__label">备注</label>
            <span class="weui-form-preview__value">{{
              form.main.bi_remark
            }}</span>
          </div>
        </div>
      </div>
      <file-list v-model="form.main.bi_attach" />
    </div>

    <div class="footer-bar weui-dialog__ft">
      <share
        class="weui-dialog__btn weui-dialog__btn_default"
        v-if="!editable"
        :biz-data="bizData"
      ></share>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import process from "@/mixins/process.js";
import Share from "@/components/button/Share.vue";
import Collapse from "@/components/Collapse.vue";
import CustomField from "@/components/field/CustomField.vue";
import FileList from "@/components/FileList.vue";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    Share,
    Collapse,
    CustomField,
    FileList,
  },
  data() {
    return {
      baseUrl: "/api/money/billoutar",
      codeField: "bi_code",
      statusField: "bi_statuscode",
      caller: "BillOutAR",
      xtype: "money-billoutar-formpanel",
    };
  },
  computed: {
    bizData() {
      var main = this.form.main;
      if (!main) {
        return null;
      }
      return {
        bizCode: main.bi_code,
        bizType: "BillOutAR",
        bizId: main.id,
        viewType: "money-billoutar-formpanel",
        title: "应收发票" + main.bi_code,
      };
    },
  },
  
};
</script>